import React from 'react';
import styles from './styles.module.css';
import FilterSection from './FilterSection';
import { CircularProgress } from '@mui/material';

const FilterPanel = ({
  setDisplay,
  options,
  filters,
  setFilters,
  resetFilters,
  apply,
  lastItemTitle = 'SSL',
  includeLabel = false,
}) => {
  const applyFilters = () => {
    apply();
    setDisplay(false);
  };

  return (
    <div className={styles.panel}>
      {!options.length > 0 ? (
        <div className={styles.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        options.map(({ category, title, options, disabled }) => (
          <FilterSection
            key={category}
            title={title}
            category={category}
            options={options}
            setFilters={setFilters}
            filters={filters}
            lastItemTitle={lastItemTitle}
            includeLabel={includeLabel}
            disabled={disabled}
          />
        ))
      )}

      <div className={styles.FilterButtonsContainer}>
        <button
          onClick={() => {
            resetFilters();
            setDisplay(false);
          }}
          className={styles.resetButton}>
          Reset
        </button>
        <button
          onClick={() => {
            applyFilters();
            setDisplay(false);
          }}
          className={styles.applyButton}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
